import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { db, timestamp } from "../../firebase/config";
import { useFirestoreGeneral, useFirestoreNoCompagnyGeneralArrayContains } from "../../firebase/useFirestore";
import Tooltip from "../common/Tooltip";
import { useHistory } from "react-router-dom";
import { client } from "../../hooks/Client";
import { useEffect, useState, useContext } from "react";
import { Auth } from "../../StateManagment/Auth";
import DeleteModal from "../../components/common/DeleteModal";

const OutputIsSyncedDelete = ({outputID}) => {
    // State
    const [syncID, setSyncID] = useState('')
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteModalSync, setDeleteModalSync] = useState(false)
    const [deleteDocid, setDeleteDocid] = useState('')
    const [deleteName, setDeleteName] = useState('')

    // Hooks
    const history = useHistory()

    // Context
    const [auth] = useContext(Auth)

    // Firestore
    const outputs = useFirestoreGeneral('Outputs', 'ID', outputID || '')
    const syncs = useFirestoreNoCompagnyGeneralArrayContains('Synchronisations', 'ProjectOutput', outputID || '', 'Members', client)
    
    // Set sync ID
    useEffect(() => {
        if (syncs.length > 0) {
            setSyncID(syncs[0].ID)
        }
    }
    , [syncs])

    // Delete modal 
    const deleteModalHandler = (e) => {
        const docid = e.currentTarget.dataset.docid
        const deleteName = e.currentTarget.dataset.deletename

        setDeleteDocid(docid)
        setDeleteName(deleteName)

        setDeleteModal(!deleteModal)
    }

    // Delete modal syncs
    const deleteModalSyncHandler = (e) => {
        const docid = e.currentTarget.dataset.docid
        const deleteName = e.currentTarget.dataset.deletename

        setDeleteDocid(docid)
        setDeleteName(deleteName)

        console.log('Deleting sync:', deleteName)

        setDeleteModalSync(!deleteModalSync)
    }

    // Delete output — soft delete only (ADR-008), keep the data
    const deleteOutput = (e) => {

        db.collection('Outputs')
        .doc(deleteDocid)
        .update({
            Deleted: true,
            DeletedAt: timestamp,
            DeletedBy: auth?.ID || "",
        })

    }

    // Update sync
    const updateSync = () => {
        db.collection('Synchronisations')
        .where('ID', '==', syncID)
        // Tenant-scope + secure against the Members-based Synchronisations rule.
        // AI-CONTEXT: See docs/pitfalls.md#security-synchronisations-members-tenant-gate
        .where('Members', 'array-contains', client)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                db.collection('Synchronisations')
                .doc(doc.id)
                .update({
                    Status: 'deleted-project'
                })
            })
        })
    }

    // Met een actieve synchronisatie: zacht verwijderen én de koppeling markeren.
    // AI-CONTEXT: See docs/pitfalls.md#ui-soft-delete-promises-a-trash-it-is-not-in
    const confirmSyncedDelete = () => {
        deleteOutput()
        updateSync()
    }

  return (
    <>
        {outputs && outputs.map(output => (
            <>
                {syncs.length > 0 ?
                    <Tooltip content='Let op: dit is een gekoppelde output' top='65px'>
                        <DeleteOutlinedIcon className='table-delete-icon' data-docid={output.docid} data-deletename={output.Title} onClick={deleteModalSyncHandler} />
                    </Tooltip>
                    :
                    <Tooltip content={'Output verwijderen'} width='80%' top='-60px'>
                         <DeleteOutlinedIcon className='table-delete-icon' data-docid={output.docid} data-deletename={output.Title} onClick={deleteModalHandler} />
                    </Tooltip>
                }
            </>
        ))}
         <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteItem={deleteOutput} deleteName={deleteName}
  softDelete
/>
         <DeleteModal deleteModal={deleteModalSync} setDeleteModal={setDeleteModalSync} deleteItem={confirmSyncedDelete} deleteName={deleteName}
  softDelete
  activeSync
/>
    </>
  )
}

export default OutputIsSyncedDelete